import { render, staticRenderFns } from "./NewDataSearchWidget.vue?vue&type=template&id=79c02d10&"
import script from "./NewDataSearchWidget.vue?vue&type=script&lang=ts&"
export * from "./NewDataSearchWidget.vue?vue&type=script&lang=ts&"
import style0 from "./NewDataSearchWidget.vue?vue&type=style&index=0&id=79c02d10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports